export default "__VITE_ASSET__BXhyzIkH__"